<form>
  <input [name]="'individuellesPortfolioInitial'" [(ngModel)]="hiddenModel" class="lv-individuelles-portfolio-hidden-form">
  <ng-container *ngIf="fondsPortfolioData$ | async as fondsPortfolioData$">
    <ng-container *ngIf="(uiArtefakt.FeldnameExtern === '/listePortfolio' && fondsPortfolioData$.isAnlagestrategieIndividuell) ||
                       (uiArtefakt.FeldnameExtern === '/listePortfolioZuzahlung' && fondsPortfolioData$.isAnlagestrategieIndividuellZuzahlung)">
      <div class="lv-artefact-container CardLayoutNeutral">
        <div class="lv-individuelles-portfolio-titelzeile">
          <div class="lv-individuelles-portfolio-fonds-title" [class.lv-individuelles-portfolio-margin-bottom-null]="!isVermittlerspezifischesPortfolioMoeglich"
               [innerHTML]="'FONDS.PORTFOLIO_INDIVIDUELL' | translate"></div>
          <ng-container *ngIf="dataSource?.data.length">
            <ng-container *ngIf="!!risikoklasseGesamt">
              <div class="lv-gemanagte-portfolioloesung-item-risikoklasse">SRI {{ risikoklasseGesamt }}</div>
            </ng-container>
            <ng-container *ngIf="!risikoklasseGesamt">
              <div class="lv-gemanagte-portfolioloesung-item-risikoklasse">SRI -</div>
            </ng-container>
          </ng-container>
        </div>
        <ng-container *ngIf="isVermittlerspezifischesPortfolioMoeglich">
          <div class="lv-individuelles-portfolio-fonds-hinweis" [innerHTML]="'FONDS.PORTFOLIO_NEU_ODER_VORLAGE' | translate"></div>
          <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
            <mat-form-field class="lv-material-form-input" color="accent">
              <div class="lv-input-field">
                <mat-select #dropdownIndividuellesPortfolio [ngModel]="selectedVermittlerspezifischesPortfolio.name"
                            [hideSingleSelectionIndicator]="true" [name]="'dropdownIndividuellesPortfolio'">
                  <mat-option value="0">
                    <div (click)="onSelectionIndividuellesPortfolioClicked($event, {})" class="lv-fonds-hinzufuegen-button-content">
                      Neues Portfolio
                    </div>
                  </mat-option>
                  <mat-option disabled>
                    <div class="lv-fonds-table-mat-option-with-line">
                      <div class="lv-fonds-table-mat-option-with-line-div"
                           [innerHTML]="'FONDS.DROPDOWN.PORTFOLIO_VORLAGEN' | translate"></div>
                    </div>
                  </mat-option>
                  <ng-container *ngIf="!!gespeicherteVermittlerspezifischePortfolios?.length">
                    <mat-option *ngFor="let portfolio of gespeicherteVermittlerspezifischePortfolios" [value]="portfolio.name"
                                (click)="onSelectionIndividuellesPortfolioClicked($event, portfolio)" class="lv-mat-option-multiline">
                      {{ portfolio.name }}
                    </mat-option>
                  </ng-container>
                  <ng-container *ngIf="!gespeicherteVermittlerspezifischePortfolios?.length">
                    <mat-option class="lv-fonds-table-mat-option-with-line-div-disabled" disabled>
                      <div [innerHTML]="'FONDS.DROPDOWN.PORTFOLIO_KEINE_VORLAGEN_VORHANDEN' | translate"></div>
                    </mat-option>
                  </ng-container>
                </mat-select>
              </div>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="showDevButtonsVermittlerspezifischesPortfolio">
          <div>
            <button (click)="onDeleteAllPortolios()" style="margin-right: 10px" mat-raised-button color="warn">Alle Portfolios löschen</button>
            <button (click)="onCreateTestDataPortfolios()" mat-raised-button color="primary">Portfolio Testdaten erstellen</button>
          </div>
        </ng-container>
        <div *ngIf="selectedIndividualFonds$ | async as selectedIndividualFonds">
          <input [name]="'lvHidden'" [(ngModel)]="hiddenModel" class="lv-individuelles-portfolio-hidden-form" [required]="true">
          <ng-container *ngIf="!dataSource?.data.length">
            <div class="lv-individuelles-portfolio-fonds-hinzufuegen">
              <div class="lv-fonds-hinzufuegen-button">
                <button mat-raised-button color="primary" (click)="fondsIndividuellClicked()">
                  <div class="lv-fonds-hinzufuegen-button-content">
                    <div>
                      <mat-icon class="lv-fonds-hinzufuegen-button-icon" [svgIcon]="'CirclePlus'"></mat-icon>
                    </div>
                    <div>Fonds hinzufügen</div>
                  </div>
                </button>
              </div>
              <lv-inline-fehlermeldung *ngIf="hasError()"
                                       translationKeyFehlermmeldung="ERRORS.INDIVIDUELLE_FONDS_FEHLEN"></lv-inline-fehlermeldung>
            </div>
          </ng-container>

          <ng-container *ngIf="!!dataSource?.data.length">
            <div class="lv-individuelles-portfolio-header">
              <div>
                <button mat-button color="accent" (click)="gleichgewichten()">
                  <mat-icon color="accent" [svgIcon]="'ScaleBalanced'"></mat-icon>
                  <span class="lv-text-margin-left">Anteile gleichgewichten</span>
                </button>
              </div>
            </div>

            <table class="lv-fonds-table" #fondsTable mat-table [dataSource]="dataSource" matSort matSortActive="name"
                   matSortDirection="asc" matSortDisableClear>
              <ng-container matColumnDef="anteil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">Anteil</th>
                <td #anteil mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell">
                  <div class="lv-fonds-table-data-cell-anteil">
                    <lv-material-form-input #anteil="ngModel" [unit]="'COMMON.UNIT.PROZENT'"
                                            lvMinMaxValidator [minValue]="1"
                                            [maxValue]="100"
                                            [selectAllOnFocus]="true"
                                            (inputChange)="onChangeAnteil($event, element.fondsId, anteil.valid)"
                                            [ngModel]="element.anteil"
                                            [name]="element.fondsId"
                                            [outerErrors]="getErrors(element.fondsId)"
                                            [isTouched]="isTouched(element.fondsId)"
                                            [isDirty]="isTouched(element.fondsId)"
                                            [autocomplete]="autocomplete"
                                            [required]="true">
                    </lv-material-form-input>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">Fondsname / ISIN</th>
                <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-cell-width-400">
                  <ng-container>{{ element.name }} <br> {{ element.isin }} {{ element.markAsNichtVerfuegbar }}</ng-container>
                  <ng-container *ngIf="!!element.markAsNichtVerfuegbar">
                    <lv-inline-fehlermeldung translationKeyFehlermmeldung="ERRORS.FONDS_NICHT_VERFUEGBAR"></lv-inline-fehlermeldung>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="risikoklasse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">SRI</th>
                <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell">
                  <ng-container>{{ element.risikoklasse }}</ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="factsheet">
                <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">Factsheet</th>
                <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon">
                  <ng-container>
                    <a href="{{getLink('Factsheet', element.fondsId)}}" target="_blank">
                      <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
                    </a>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="esgreport">
                <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">ESG-Report</th>
                <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon">
                  <ng-container>
                    <a href="{{getLink('ESG-Report', element.fondsId)}}" target="_blank">
                      <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
                    </a>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell"></th>
                <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon">
                  <ng-container>
                    <mat-icon class="" [svgIcon]="'Trash'" (click)="deleteFonds(element.fondsId)"></mat-icon>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="fondshinzufuegen-first-td">
                <td mat-footer-cell *matFooterCellDef> &nbsp;</td>
              </ng-container>
              <ng-container matColumnDef="fondshinzufuegen-second-td">
                <td mat-footer-cell *matFooterCellDef colspan="5">
                  <div class="lv-fonds-hinzufuegen-button">
                    <button mat-button color="primary" onclick="this.blur()" (click)="fondsHinzufuegen()">
                      <div class="lv-fonds-hinzufuegen-button-content">
                        <div>
                          <mat-icon class="lv-fonds-hinzufuegen-button-icon" [svgIcon]="'CirclePlus'"></mat-icon>
                        </div>
                        <div>Fonds hinzufügen</div>
                      </div>
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="gesamtportfolio-first-td">
                <td class="lv-fonds-table-footer lv-fonds-gesamtportfolio-first-td lv-fonds-table-data-cell-anteil" mat-footer-cell
                    *matFooterCellDef>
                  {{ kumulierteAnteile }}&nbsp;&nbsp;%
                </td>
              </ng-container>
              <ng-container matColumnDef="gesamtportfolio-second-td">
                <td mat-footer-cell *matFooterCellDef>
                  Gesamtportfolio
                </td>
              </ng-container>
              <ng-container matColumnDef="gesamtportfolio-third-td">
                <td mat-footer-cell *matFooterCellDef colspan="4">
                  <span *ngIf="!!risikoklasseGesamt"> {{ risikoklasseGesamt }}</span>
                  <span *ngIf="!risikoklasseGesamt">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="gesamtportfolio-fehler-first-td">
                <td mat-footer-cell *matFooterCellDef>
                  <div *ngIf="showKumulierteAnteileNichtKorrekt">
                    &nbsp;
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="gesamtportfolio-fehler-second-td">
                <td mat-footer-cell *matFooterCellDef colspan="5">
                  <div *ngIf="showKumulierteAnteileNichtKorrekt" class="lv-fonds-hinzufuegen-error-second-td">
                    <lv-inline-fehlermeldung
                        translationKeyFehlermmeldung="ERRORS.GESAMTPORTFOLIO_UNGLEICH_EINHUNDERT_PROZENT"></lv-inline-fehlermeldung>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr mat-footer-row *matFooterRowDef="['fondshinzufuegen-first-td', 'fondshinzufuegen-second-td']"
                  class="lv-fonds-hinzufuegen-top-line lv-fonds-hinzufuegen-bottom-line">
              </tr>
              <tr mat-footer-row *matFooterRowDef="['gesamtportfolio-first-td', 'gesamtportfolio-second-td', 'gesamtportfolio-third-td']"
                  class="lv-fonds-table-footer lv-fonds-gesamtportfolio">
              </tr>
              <tr mat-footer-row *matFooterRowDef="['gesamtportfolio-fehler-first-td', 'gesamtportfolio-fehler-second-td']"
                  class="lv-fonds-table-footer">
              </tr>
            </table>
          </ng-container>
          <ng-container *ngIf="isVermittlerspezifischesPortfolioMoeglich"> <!-- falls Benutzer authenticated -->
            <div *ngIf="!!dataSource?.data.length" class="lv-fonds-portfolio-speichern">
              <button mat-raised-button onclick="this.blur()" color="accent" (click)="onFondsSpeichern()">
                Portfolio speichern
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>
